<template>
  <div class="aigc-create-recent">
    <div class="aigc-create-recent-title">创作案例</div>
    <div class="aigc-create-recent-grid">
      <div
        v-for="it in items"
        :key="it.id"
        class="aigc-create-recent-item"
        @click="$emit('select', it)"
      >
        <video
          v-if="it.taskType === 'video' && it.url"
          :src="it.url"
          :poster="it.cover || ''"
          muted
          playsinline
          class="aigc-create-recent-video"
        ></video>
        <van-image
          v-else-if="displayUrl(it)"
          width="100%"
          height="100%"
          fit="cover"
          :src="displayUrl(it)"
        />
        <van-icon
          v-if="it.taskType === 'video' && it.url"
          name="play-circle-o"
          class="aigc-create-recent-play"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { AIGC_GUEST_SHOWCASE } from "./aigcGuestShowcase";

export default {
  name: "AigcGuestShowcase",
  data() {
    return {
      items: AIGC_GUEST_SHOWCASE,
    };
  },
  methods: {
    displayUrl(it) {
      if (!it) return "";
      if (it.taskType === "video") return it.cover || it.url || "";
      return it.url || "";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/aigc/AigcGuestShowcase.vue